import * as React from 'react';
import PropTypes from 'prop-types';
import { MultiGrid, AutoSizer } from 'react-virtualized';
import { RotateMe } from './rotateMe';
import { registerHook, unregisterHook } from '../../store/clickWrapper';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { STYLE, STYLE_BOTTOM_LEFT_GRID, STYLE_TOP_LEFT_GRID, STYLE_TOP_RIGHT_GRID, STYLE_ROWS } from "./fixedTableStyles";
import classnames from "classnames";

import "./fixedTable.scss";
import Arrow from "../../img/icons/BBiconsRozbalit";

class FixedTable extends React.Component {
    initialState = { tooltippedCellKey: null, tooltipContent: null, scrollOffset: null, hover: false };
    state = { ...this.initialState };
    cells = {};
    isDark = false;
    static propTypes = {
        columnWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,
        rowHeight: PropTypes.number.isRequired,
        fixedRowCount: PropTypes.number.isRequired,
        height: PropTypes.number,
        cellStyle: PropTypes.object,
        hideRotateHelper: PropTypes.bool,
        columnCount: PropTypes.number.isRequired,
        fixedColumnCount: PropTypes.number.isRequired,
        data: PropTypes.array.isRequired
    };

    static defaultProps = {
        columnWidth: 100,
        rowHeight: 25,
        fixedRowCount: 1,
        height: null,
        cellStyle: {},
        hideRotateHelper: false,
        columnCount: 1,
        fixedColumnCount: 1,
        data: []
    };

    componentDidMount() {
        this.hookId = registerHook(this, _ => this.setState({ ...this.initialState }));
    }

    render() {
        if (!isNullOrUndefined(localStorage) && !isNullOrUndefined(localStorage.locales_theme) && localStorage.locales_theme === 'dark')
            this.isDark = true;

        return (
            <AutoSizer className={classnames({ 'fixed-table': true, 'only-mobile': this.props.onlyMobile, 'print-hidden': this.props.printHidden, 'with-arrows': true })} disableHeight >
                {({ width }) => (
                    <div className="multi-grid-wrap"
                        onMouseEnter={() => this.setState({hover: true})}
                        onMouseLeave={() => this.setState({hover: false})}>
                        <MultiGrid
                            ref={el => this.gridRef = el}
                            fixedColumnCount={this.props.fixedColumnCount}
                            fixedRowCount={this.props.fixedRowCount}
                            scrollToColumn={0}
                            scrollToRow={0}
                            cellRenderer={this.cellRenderer.bind(this)}
                            columnWidth={this.props.columnWidth} //statements + headertypes + names
                            columnCount={this.props.columnCount}
                            enableFixedColumnScroll
                            enableFixedRowScroll
                            height={this.height()} //items + 2 (header rowr) * 25 (rowHeight + 20 (scrollbar))
                            rowHeight={this.props.rowHeight}
                            rowCount={this.props.data.length}
                            style={STYLE}
                            styleBottomLeftGrid={STYLE_BOTTOM_LEFT_GRID(this.isDark)}
                            styleTopLeftGrid={STYLE_TOP_LEFT_GRID(this.isDark)}
                            styleTopRightGrid={STYLE_TOP_RIGHT_GRID(this.isDark)}
                            width={width}
                            hideTopRightGridScrollbar
                            hideBottomLeftGridScrollbar
                            onScroll={({ scrollTop }) => this.setState(state => state.scrollTop === scrollTop ? {} : { scrollOffset: scrollTop })}

                        >

                        </MultiGrid>
                        {
                            <>
                                <div className="arrow-wrap left" onClick={() => this.onLeftClick()}><Arrow /></div>
                                <div className="arrow-wrap right" onClick={() => this.onRightClick()} style={{left: `calc(${width}px - 60px)`}}><Arrow /></div>
                            </>
                        }
                        {this.state.tooltipContent && this.cells[this.state.tooltippedCellKey] && this.computeTooltipTop() > 0 &&
                            this.computeTooltipTop() < this.state.height && <span className='fixed-table-tooltip' style={{
                                top: `calc(1.5em + ${this.computeTooltipTop()}px)`,
                                left: `calc(1em + ${parseInt(this.state.tooltippedCellKey.split('-')[1]) * this.props.columnWidth}px)`
                            }}>
                                {this.state.tooltipContent}
                            </span>
                        }

                        {!this.props.hideRotateHelper && <RotateMe />}
                    </div>
                )}
            </AutoSizer>
        );
    }
    onRightClick(){
        if(this.gridRef){
            let gridWidth = this.props.columnWidth *  this.props.columnCount;
            this.gridRef._onScroll({scrollLeft: this.gridRef.state.scrollLeft + this.gridRef._lastRenderedWidth > gridWidth ?  this.gridRef.state.scrollLeft  : this.gridRef.state.scrollLeft + this.props.columnWidth  });
        }
    }
    onLeftClick(){
        if(this.gridRef){
            this.gridRef._onScroll({scrollLeft: this.gridRef.state.scrollLeft < 100 ? 0 : this.gridRef.state.scrollLeft - this.props.columnWidth });
        }
    }
    componentWillUnmount() {
        unregisterHook(this.hookId);
    }

    cellRenderer(props) {
        const { key, style, rowIndex, columnIndex, parent } = props;
        const rowData = !Array.isArray(this.props.data[rowIndex]) ? this.props.data[rowIndex].data : this.props.data[rowIndex]
        const rowClass = !Array.isArray(this.props.data[rowIndex]) ? this.props.data[rowIndex].className : undefined;
        const forcedClass = !Array.isArray(this.props.data[rowIndex]) ? this.props.data[rowIndex].forcedClass : false
        return (
            <div
                className={rowClass}
                key={key} style={style}
                ref={el => { if (typeof rowData[columnIndex] === 'string') { this.cells[key] = el } }}
                onClick={_ => this.showTooltip(key, rowIndex, columnIndex, parent)}>
                <div title={rowData[columnIndex]} className={columnIndex === 0 ? "no-overflow" : ""}
                    style={STYLE_ROWS(this.isDark, rowIndex, !forcedClass && (isNullOrUndefined(rowClass) || rowIndex % 2 === 0), this.props.cellStyle)}
                >
                    {rowData[columnIndex]}
                </div>
            </div>
        )
    }

    showTooltip = (key, rowIndex, columnIndex, parent) => {
        typeof this.props.data[rowIndex][columnIndex] === 'string' && parent._bottomLeftGrid &&
            this.setState({
                tooltippedCellKey: key,
                tooltipContent: this.props.data[rowIndex][columnIndex],
                scrollOffset: parent._bottomLeftGrid._scrollingContainer.scrollTop
            });
    }

    computeTooltipTop = () => (parseInt(this.state.tooltippedCellKey.split('-')[0], 10) + this.props.fixedRowCount) * this.rowHeight - this.state.scrollOffset;

    height = () => isNullOrUndefined(this.props.height) ? this.props.data.length * this.props.rowHeight + 20 : this.props.height;
}

export default FixedTable;